exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-light-red[data-v-8c3ce374] {\n  background: #f87676;\n}\n.btn-purple[data-v-8c3ce374] {\n  background: #6e7ff2;\n}\n.btn-yellow[data-v-8c3ce374] {\n  background: #f8f582;\n}\n", ""]);

// exports
